import { FunctionComponent } from 'react';

import { DocumentSignerContainer } from '@components/DocumentSigner/DocumentSigner.container';
import { Home } from '@components/Home/Home';
import { ImagesContainer } from '@components/Images/Images.container';
import { NotificationContainer } from '@components/Notification/Notification.container';
import { Profile } from '@components/Profile/Profile';
import { SampleAuthRequest } from '@components/SampleAuthRequest/SampleAuthRequest';
import { SampleRequest } from '@components/SampleRequest/SampleRequest';

export const AppRoutes: Record<string, FunctionComponent<any>> = {
  '/': Home,
  '/profile': Profile,
  '/sample-request': SampleRequest,
  '/sample-auth-request': SampleAuthRequest,
  '/images': ImagesContainer,
  '/notificatiion': NotificationContainer,
  '/document-signer': DocumentSignerContainer,
};
